export const EditMenu = {
  generalSettings: 'generalSettings',
  iframeCode: 'iframeCode',
  questions: 'questions',
  results: 'results',
};
